import { render, staticRenderFns } from "./DetaljiVozila.vue?vue&type=template&id=33d592f7&scoped=true&"
import script from "./DetaljiVozila.vue?vue&type=script&lang=ts&"
export * from "./DetaljiVozila.vue?vue&type=script&lang=ts&"
import style0 from "./DetaljiVozila.vue?vue&type=style&index=0&id=33d592f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d592f7",
  null
  
)

export default component.exports